import isToday from './is-today';

export { isToday };

export default isToday;
